var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Menu } from '@headlessui/react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { store, useAppSelector } from '../../../../../store';
import { participantsSelector } from '../../../../../store/slices/participantSlice';
import { sendWebsocketMessage } from '../../../../../helpers/websocket';
import { DataMessage, DataMsgBodyType, DataMsgType, } from '../../../../../helpers/proto/plugnmeet_datamessage_pb';
const WebcamMenuItem = ({ userId }) => {
    var _a, _b;
    _react_refresh_temp_2();
    const { t } = useTranslation();
    const participant = useAppSelector((state) => participantsSelector.selectById(state, userId));
    const roomFeatures = (_a = store.getState().session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.room_features;
    const session = store.getState().session;
    const [text, setText] = useState('Ask to share Webcam');
    const [task, setTask] = useState('');
    useEffect(() => {
        if ((participant === null || participant === void 0 ? void 0 : participant.videoTracks) === 0) {
            setText(t('left-panel.menus.items.ask-to-share-webcam').toString());
            setTask('left-panel.menus.items.share-webcam');
        }
        else {
            setText(t('left-panel.menus.items.ask-to-stop-webcam').toString());
            setTask('left-panel.menus.items.stop-webcam');
        }
    }, [t, participant === null || participant === void 0 ? void 0 : participant.videoTracks]);
    const onClick = () => {
        var _a, _b, _c, _d, _e;
        const dataMsg = new DataMessage({
            type: DataMsgType.SYSTEM,
            roomSid: session.currentRoom.sid,
            roomId: session.currentRoom.room_id,
            to: userId,
            body: {
                type: DataMsgBodyType.INFO,
                from: {
                    sid: (_b = (_a = session.currentUser) === null || _a === void 0 ? void 0 : _a.sid) !== null && _b !== void 0 ? _b : '',
                    userId: (_d = (_c = session.currentUser) === null || _c === void 0 ? void 0 : _c.userId) !== null && _d !== void 0 ? _d : '',
                },
                msg: t('left-panel.menus.notice.asked-you-to', {
                    name: (_e = session.currentUser) === null || _e === void 0 ? void 0 : _e.name,
                }) + t(task),
            },
        });
        sendWebsocketMessage(dataMsg.toBinary());
        toast(t('left-panel.menus.notice.you-have-asked', {
            name: participant === null || participant === void 0 ? void 0 : participant.name,
        }) + t(task), {
            toastId: 'asked-status',
            type: 'info',
        });
    };
    const render = () => {
        return (_jsx("div", { className: "", role: "none", children: _jsx(Menu.Item, { children: () => (_jsx("button", { className: "text-gray-900 dark:text-darkText group flex rounded-md items-center text-left w-full px-2 py-[0.4rem] text-xs lg:text-sm transition ease-in hover:bg-primaryColor hover:text-white", onClick: () => onClick(), children: text })) }) }));
    };
    return (_jsx(_Fragment, { children: ((_b = session.currentUser) === null || _b === void 0 ? void 0 : _b.userId) !== (participant === null || participant === void 0 ? void 0 : participant.userId) &&
            (roomFeatures === null || roomFeatures === void 0 ? void 0 : roomFeatures.allow_webcams) &&
            !roomFeatures.admin_only_webcams
            ? render()
            : null }));
};
_react_refresh_temp_1 = WebcamMenuItem;
$RefreshReg$(_react_refresh_temp_1, "WebcamMenuItem");
_react_refresh_temp_2(WebcamMenuItem, "xgrn17XYGWu3/ONV0KQVEaVUL1c=", false, () => [useTranslation, useAppSelector]);
export default WebcamMenuItem;
